<template>
    <div class="floatingsv2" v-if="floatings && floatings.length > 0">
        <div class="title">
            <div class="left">
                <span
                    v-html="$translate('USER_LIKE_TITLE').replace(/%s/, $nameOrNick($store.getters.chat.user))"
                ></span>
                <span class="count">{{ (floatings || []).length }}</span>
            </div>
            <div class="delete-all" @click="deleteAll">전체삭제</div>
        </div>
        <transition-group name="list" class="floatingv2-items flex-row">
            <FloatingV2
                class="flex-wrap list-item"
                :floating="floating"
                :chatId="floating.chat_id"
                :key="floating.id"
                v-for="floating in floatings"
            />
        </transition-group>
    </div>
</template>

<script>
import FloatingV2 from './FloatingV2'
import chatFloatingService from '@/services/chat-floating'

export default {
    name: 'FloatingsV2',
    components: { FloatingV2 },
    computed: {
        floatings() {
            const chat = this.$store.getters.chat
            if (!chat) return

            return chat.$$floatingsInterest
        },
        floatingIds() {
            return this.floatings.map(f => f.id)
        },
        chat() {
            return this.$store.getters.chat
        },
    },
    methods: {
        async deleteAll() {
            const idx = await this.$modal.basic({
                body: '호감박스를 제거하시겠습니까?',
                buttons: [
                    {
                        label: '취소',
                        class: 'btn-default',
                    },
                    {
                        label: '확인',
                        class: 'btn-primary',
                    },
                ],
            })
            if (idx) {
                try {
                    const { msg } = await chatFloatingService.deleteAll(this.chat.id, this.floatingIds)
                    if (msg) {
                        this.$loading(true)
                        const floatingsRemoved = { ...this.chat, $$floatingsInterest: [] }
                        this.$store.commit('setChat', floatingsRemoved)
                        this.$toast.success('호감박스가 제거되었습니다.')
                    }
                } catch (e) {
                    this.$toast.error('호감박스 제거에 실패했어요')
                } finally {
                    this.$loading(false)
                }
            }
        },
    },
}
</script>
